export default "__VITE_ASSET__CR_ApA2x__"